export default __webpack_public_path__ + "static/media/LiquidWater_Pipe.256.649744f5.png";